import {DataGridPro, GridFilterInputValue, GridFilterModel, GridSortModel, useGridApiRef} from "@mui/x-data-grid-pro";
import React, {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
    GetDistricts,
    GetRequestsList,
    onChangeRowActiveStatus,
    onSetCurrentDistrict,
    onSetCurrentPage,
    onSetCurrentRegion,
    onSetDistricts,
    onSetGridRows,
    selectCurrentPage,
    selectDefaultDistricts,
    selectDefaultRequestsGridRows,
    selectDistricts, selectIsRequestsLoading,
    selectRequestsGridRows,
    selectSelectedDistrict,
    selectSelectedRegion
} from "../../store/requestsReducer";
import {DatePicker, Input, message, Popconfirm, Select, Spin, Switch} from 'antd';
import GridPagination from "../GridPagination/GridPagination";
import Header from "../Header/Header";
import s from './Requests.module.scss'
import {requestsAPI} from "../../app/api";
import {useNavigate} from "react-router-dom";
import {deDELocaleText} from '../../utils/dataGridLocale.de';
import {RequestsTypes} from "../../types/requestsTypes";
import {LoadingOutlined} from "@ant-design/icons";
import { normalizeGerman } from "../../helpers/funcHelper";
const {RangePicker} = DatePicker;

const Requests = () => {
    const apiRef = useGridApiRef()
    const dispatch = useAppDispatch()
    const gridRows = useAppSelector(selectRequestsGridRows)
    const defaultGridRows = useAppSelector(selectDefaultRequestsGridRows)
    const page = useAppSelector(selectCurrentPage)
    const [currentLocationMode, setCurrentLocationMode] = useState('All')
    const [searchTerm, setSearchTerm] = useState('')
    const navigate = useNavigate()
    const districts = useAppSelector(selectDistricts)
    const selectedDistrict = useAppSelector(selectSelectedDistrict)
    const selectedRegion = useAppSelector(selectSelectedRegion)
    // const [selectedDistrict, setSelectedDistrict] = useState('Select district')
    // const [selectedRegion, setSelectedRegion] = useState('Select region')
    const [regions, setRegions] = useState<any>([])
    const [regionsData, setRegionsData] = useState<any>()
    const defaultDistricts = useAppSelector(selectDefaultDistricts)
    const [filterModel, setFilterModel] = useState<GridFilterModel>({items: []});
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const isDataLoading = useAppSelector(selectIsRequestsLoading)

    useEffect(() => {
        dispatch(GetRequestsList())
        dispatch(GetDistricts())
        requestsAPI.getRegions()
            .then((res) => {
                const regionsNames = res.data.regions.map((r: any) => ({value: r.name, label: r.name}))
                setRegions(regionsNames)
                setRegionsData(res.data.regions)
            })
    }, [dispatch])

    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return; // prevent running multiple times
        if (!gridRows.length) return; // wait until rows are loaded
        if (!regions.length) return;
        setTimeout(() => {
            const district = JSON.parse(sessionStorage.getItem("district")!)
            const region = JSON.parse(sessionStorage.getItem("region")!)
            if (region !== null && district !== null) {
                handleLangChangeRegion(region);
                setTimeout(() => {
                    handleLangChangeDistrict(district);
                }, 200);
                sessionStorage.removeItem("region");
                sessionStorage.removeItem("district");
            } else if (region !== null && district === null) {
                handleLangChangeRegion(region);
                sessionStorage.removeItem("region");
            } else if (district !== null && region === null) {
                handleLangChangeDistrict(district);
                sessionStorage.removeItem("district");
            }
            didRun.current = true; // mark as done
        }, 500)

    }, [gridRows, dispatch]);// eslint-disable-line


    const onRemoveRequest = (id: number) => {
        requestsAPI.removeRequestById(id)
            .then(() => {
                message.success('Request was successfully deleted')
                dispatch(GetRequestsList())
            })
    }

    const districtsOptions = [
        {value: 'All districts', label: 'All districts'},
        ...districts.map((d) => ({
            value: d.name,
            label: d.name
        }))
    ];

    const regionsOptions = regions!?.concat({value: 'All regions', label: 'All regions'})

    const onEditRequest = (id: number) => {
        navigate(`/request/${id}`)
        if(selectedRegion !== 'Select region'){
            sessionStorage.setItem(
                "region",
                JSON.stringify(selectedRegion)
            );
        }
        if(selectedDistrict !== 'Select district'){
            sessionStorage.setItem(
                "district",
                JSON.stringify(selectedDistrict)
            );
        }

    }

    const handleConfirm = (id: number) => {
        onRemoveRequest(id);
    };

    const handleActiveStatusChange = (rowId: number, checked: boolean, row: RequestsTypes) => {
        dispatch(onChangeRowActiveStatus({rowId, status: checked}))

        const allowedKeys = [
            "title", "description", "status", "icon_type", "topic",
            "location", "location_type", "district", "quarter", "street", "house_no",
            "user_first_name", "user_last_name", "user_email", "user_phone", "is_active"
        ];
        const filteredFields = Object.fromEntries(
            Object.entries(row!!).filter(([key]) => allowedKeys.includes(key))
        );
        requestsAPI.updateRequest(Number(rowId), {
            ...filteredFields,
            status: row.status.id,
            is_active: !checked,
            icon_type: row.icon_type.id,
            topic: row.topic.id,
            location: row.location !== null ? row.location.type === 'Point'
                    ? `POINT (${row.location.coordinates.point[0]} ${row.location.coordinates.point[1]})`
                    : row.location.type === 'Polygon'
                        ? `POLYGON ((${row.location.coordinates.polygon[0].map(([lat, lng]: any) => `${lat} ${lng}`).join(', ')}))`
                        : `LINESTRING (${row.location.coordinates.line.map(([lat, lng]: any) => `${lat} ${lng}`).join(', ')})`
                : null
        })


    };

    const handleLangChangeDistrict = (value: string) => {
        dispatch(onSetCurrentDistrict(value))
        console.log(value)
        if (value === 'All districts') {
            if (selectedRegion === 'Hamburg') {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 1)))
            } else if (selectedRegion === 'Kiel') {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 2)))
            } else {
                dispatch(onSetGridRows(defaultGridRows))
            }
        }
        else if(value === 'Bezirk auswählen'){
            dispatch(onSetGridRows(defaultGridRows))
        }
        else {
            if (selectedRegion === 'Hamburg') {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 1).filter((r) => r.district !== null && r.district === value)))
            } else if (selectedRegion === 'Kiel') {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 2).filter((r) => r.district !== null && r.district === value)))
            } else {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => r.district !== null && r.district === value)))
            }
        }
    }

    const handleLangChangeRegion = (value: string) => {
        dispatch(onSetCurrentRegion(value))
        const region = JSON.parse(sessionStorage.getItem("region")!)
        if(!region){
            dispatch(onSetCurrentDistrict('Select district'))
        }
        else if(value === 'Region auswählen'){
            dispatch(onSetGridRows(defaultGridRows))
        }
        if (value === 'All regions') {
            dispatch(onSetGridRows(defaultGridRows))
            dispatch(onSetDistricts(defaultDistricts))
        } else if (value === 'Kiel') {
            const hamburgDistricts = regionsData!?.find((r: any) => r.name === "Kiel");
            const allowedNames = new Set(hamburgDistricts?.districts.map((d: any) => d.name));
            const filtered = defaultDistricts.filter(d => allowedNames.has(d.name)).map((d) => ({
                name: d.name,
                description: d.description,
                id: d.id
            }));
            dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 2)))
            dispatch(onSetDistricts(filtered))
        } else if (value === 'Hamburg') {
            const hamburgDistricts = regionsData!?.find((r: any) => r.name === "Hamburg");
            const allowedNames = new Set(hamburgDistricts?.districts.map((d: any) => d.name));
            const filtered = defaultDistricts.filter(d => allowedNames.has(d.name)).map((d) => ({
                name: d.name,
                description: d.description,
                id: d.id
            }));
            dispatch(onSetGridRows(defaultGridRows.filter((r) => r.region.id === 1)))
            dispatch(onSetDistricts(filtered))
        }
    }

    const columns = [
        {
            field: 'title',
            headerName: 'Titel',
            flex: 3,
            minWidth: 200,
        },
        {
            field: 'user_first_name',
            headerName: 'Vorname',
            flex: 0.5,
            minWidth: 130,
        },
        {
            field: 'user_last_name',
            headerName: 'Nachname',
            flex: 0.5,
            minWidth: 140,
        },
        // {
        //     field: 'district',
        //     headerName: 'District',
        //     flex: 0.5,
        //     minWidth: 140,
        // },
        {
            field: 'street',
            headerName: 'Standort',
            flex: 1,
            minWidth: 120,
            valueGetter: (params: any) => {
                const street = params?.row?.street ?? '';
                const district = params?.row?.district ?? '';
                return `${street} ${district}`;
            },
            renderCell: (params: any) => (
                <div>
                    {params.row?.street} {params.row?.house_no ?? ''} {params.row?.district}
                </div>
            ),
            filterOperators: [
                {
                    label: 'contains',
                    value: 'customContains',
                    getApplyFilterFn: (filterItem: any) => {
                        if (!filterItem.value) return null;

                        const searchValue = filterItem.value.toLowerCase();

                        return (cellValue: any) => {
                            const value = cellValue?.toString().toLowerCase() ?? '';
                            return value.includes(searchValue);
                        };
                    },
                    InputComponent: GridFilterInputValue,
                },
            ],
        },
        {
            field: 'date_created',
            headerName: 'Datum',
            flex: 1,
            color: '#667085',
            minWidth: 120,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.5,
            minWidth: 120,
            valueGetter: (params: any) => {
                return (
                    params.name ?? ''
                )
            },
            renderCell: (params: any) => (
                <div style={{color: '#667085'}}>{params.row?.status?.name}</div>
            )
        },
        {
            field: 'topic',
            headerName: 'Kategorie',
            flex: 0.5,
            minWidth: 130,
            valueGetter: (params: any) => {
                return (
                    params.name ?? ''
                )
            },
            renderCell: (data: any) => (
                <div style={{color: '#667085'}}>
                    <span>{data.row.topic.name}</span>
                </div>
            )
        },
        {
            field: 'icon_type',
            headerName: 'Emotion',
            flex: 0.5,
            minWidth: 120,
            valueGetter: (params: any) => {
                return (
                    params.name ?? ''
                )
            },
            renderCell: (data: any) => (
                <div style={{color: '#667085'}}>
                    <span>{data.row.icon_type.name}</span>
                </div>
            )
        },
        {
            field: 'is_active',
            headerName: 'Aktiv',
            flex: 0.5,
            minWidth: 120,
            renderCell: (data: any) => (
                <Switch
                    checkedChildren="Aktiv"
                    unCheckedChildren="Inaktiv"
                    value={data.row.is_active}
                    onChange={() => handleActiveStatusChange(data.row.id, data.row.is_active, data.row)}
                />
            )
        },
        {
            field: '_',
            headerName: '',
            flex: 0.5,
            minWidth: 90,
            sortable: false,
            filterable: false,
            pinned: 'right',
            renderCell: (data: any) => (
                <div style={{
                    marginTop: '4px'
                }}>
                    <Popconfirm
                        title="Diese Anfrage löschen?"
                        description="Diese Aktion kann nicht rückgängig gemacht werden."
                        onConfirm={() => handleConfirm(data.row.id)}
                        okText="Ja"
                        cancelText="Nein"
                        okType="danger"
                    >
                        <button className={s.actionBtn}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                 fill="none">
                                <path
                                    d="M2.5 4.99996H4.16667M4.16667 4.99996H17.5M4.16667 4.99996V16.6666C4.16667 17.1087 4.34226 17.5326 4.65482 17.8451C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8451C15.6577 17.5326 15.8333 17.1087 15.8333 16.6666V4.99996H4.16667ZM6.66667 4.99996V3.33329C6.66667 2.89127 6.84226 2.46734 7.15482 2.15478C7.46738 1.84222 7.89131 1.66663 8.33333 1.66663H11.6667C12.1087 1.66663 12.5326 1.84222 12.8452 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V4.99996M8.33333 9.16663V14.1666M11.6667 9.16663V14.1666"
                                    stroke="#667085" stroke-width="1.66667" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </Popconfirm>
                    <button className={s.actionBtn} onClick={() => onEditRequest(data.row.id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_448_2126)">
                                <path
                                    d="M14.1667 2.50005C14.3856 2.28118 14.6454 2.10756 14.9314 1.98911C15.2173 1.87066 15.5238 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7353 1.98911C17.0213 2.10756 17.2812 2.28118 17.5 2.50005C17.7189 2.71892 17.8925 2.97875 18.011 3.26472C18.1294 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1294 4.78274 18.011 5.06871C17.8925 5.35468 17.7189 5.61451 17.5 5.83338L6.25002 17.0834L1.66669 18.3334L2.91669 13.75L14.1667 2.50005Z"
                                    stroke="#667085" stroke-width="1.66667" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_448_2126">
                                    <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            )
        }
    ]

    const onChangeGridPage = (page: number) => {
        dispatch(onSetCurrentPage(page))
    }

    useEffect(() => {
        dispatch(onSetGridRows(defaultGridRows))
    }, [defaultGridRows, dispatch])

    const onLocationModeChange = (mode: string) => {
        setCurrentLocationMode(mode)
        if (mode === 'Pin') {
            dispatch(onSetGridRows(defaultGridRows.filter((r) => r.location !== null && r.location.type === 'Point')))
        } else if (mode === 'Area') {
            dispatch(onSetGridRows(defaultGridRows.filter((r) => r.location !== null && r.location.type === 'Polygon')))
        } else if (mode === 'Line') {
            dispatch(onSetGridRows(defaultGridRows.filter((r) => r.location !== null && r.location.type === 'LineString')))
        } else if (mode === 'All') {
            dispatch(onSetGridRows(defaultGridRows))
        }
    }

    const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value;
        const value = rawValue.toLowerCase();
        setSearchTerm(rawValue);

        const locationTypeMap = {
            Pin: 'Point',
            Area: 'Polygon',
            Line: 'LineString',
        } as const;

        const isSearching = value !== '';

        const stemGermanWord = (word: string): string => {
            return word
                // .replace(/(e|en|er|es|n|r|s)$/i, '') // remove common suffixes
                .toLowerCase();
        };

        const matchesSearch = (r: typeof defaultGridRows[number]) => {
            const stemmedValue = stemGermanWord(normalizeGerman(value.toLowerCase()));

            const fields = [
                r.title,
                r.user_first_name,
                r.user_last_name,
                r.street,
                r.district
            ];

            return fields.some(field => {
                const normalized = normalizeGerman(field?.toLowerCase() || '');
                return normalized.includes(stemmedValue);
            });
        };


        const filterByLocationType = (rows: typeof defaultGridRows, type: string) => {
            return rows.filter(r => r.location?.type === type);
        };

        const filterValidFields = (rows: typeof defaultGridRows) => {
            return rows.filter(r =>
                r.title && r.street && r.district && (r.user_first_name || r.user_last_name)
            );
        };

        let filteredRows = defaultGridRows;

        if (currentLocationMode in locationTypeMap) {
            // @ts-ignore
            filteredRows = filterByLocationType(filteredRows, locationTypeMap[currentLocationMode]);
        }

        if (currentLocationMode !== 'All') {
            filteredRows = filterValidFields(filteredRows);
        }

        if (isSearching) {
            filteredRows = filteredRows.filter(matchesSearch);
        }

        dispatch(onSetGridRows(filteredRows));
    };

    const onDateChange = (dates: any, dateStrings: [string, string]) => {
        const [fromDateStr, toDateStr] = dateStrings;
        const fromDate = new Date(fromDateStr);
        const toDate = new Date(toDateStr);
        if (dates === null) {
            dispatch(onSetGridRows(defaultGridRows))
        } else {
            if (currentLocationMode === 'Pin') {
                dispatch(onSetGridRows(defaultGridRows
                    .filter((r) => r.location !== null && r.location.type === 'Point')
                    .filter((r) => {
                        const rowDate = new Date(r.date_created);
                        const isWithinRange =
                            (!isNaN(rowDate.getTime()) &&
                                rowDate >= fromDate &&
                                rowDate <= toDate);
                        return isWithinRange;
                    })
                ))
            } else if (currentLocationMode === 'Area') {
                dispatch(onSetGridRows(defaultGridRows
                    .filter((r) => r.location !== null && r.location.type === 'Polygon')
                    .filter((r) => {
                        const rowDate = new Date(r.date_created);
                        const isWithinRange =
                            (!isNaN(rowDate.getTime()) &&
                                rowDate >= fromDate &&
                                rowDate <= toDate);
                        return isWithinRange;
                    })
                ))
            } else if (currentLocationMode === 'All') {
                dispatch(onSetGridRows(defaultGridRows.filter((r) => {
                    const rowDate = new Date(r.date_created);
                    const isWithinRange =
                        (!isNaN(rowDate.getTime()) &&
                            rowDate >= fromDate &&
                            rowDate <= toDate);
                    return isWithinRange;
                })))
            }
        }
    };

    const didRestore = useRef(false);

    useEffect(() => {
        if (didRestore.current) return;

        const saved = sessionStorage.getItem("gridState");
        if (saved) {
            const {filterModel, sortModel} = JSON.parse(saved);
            setFilterModel(filterModel);
            setSortModel(sortModel);
        }

        didRestore.current = true;
    }, []);

    useEffect(() => {
        if (!didRestore.current) return; // skip first run
        sessionStorage.setItem(
            "gridState",
            JSON.stringify({filterModel, sortModel})
        );
    }, [filterModel, sortModel]);


    return (
        <div>
            <Header/>
            <div className={s.inner}>
                <h1 className={s.inner__title}>Liste der Pins</h1>
                <p className={s.inner__subtitle}>Alle Pins anzeigen</p>
                <div className={s.modeButtons}>
                    <button
                        onClick={() => onLocationModeChange('All')}
                        className={currentLocationMode === 'All' ? `${s.modeButton} ${s.modeButton_active}` : s.modeButton}
                    >
                        Alle
                    </button>
                    <button
                        onClick={() => onLocationModeChange('Pin')}
                        className={currentLocationMode === 'Pin' ? `${s.modeButton} ${s.modeButton_active}` : s.modeButton}
                    >
                        Pin
                    </button>
                    <button
                        onClick={() => onLocationModeChange('Area')}
                        className={currentLocationMode === 'Area' ? `${s.modeButton} ${s.modeButton_active}` : s.modeButton}
                    >
                        Bereich
                    </button>
                    <button
                        onClick={() => onLocationModeChange('Line')}
                        className={currentLocationMode === 'Line' ? `${s.modeButton} ${s.modeButton_active}` : s.modeButton}
                    >
                        Linie
                    </button>
                </div>
                <div className={s.searchAndFilters}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <Input
                            type="text"
                            value={searchTerm}
                            placeholder={'Suchen'}
                            onChange={handleSearchInputChange}
                            className={s.searchAndFilters__searchInput}
                            prefix={
                                <svg style={{
                                    marginRight: '8px'
                                }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none">
                                    <path
                                        d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                                        stroke="#667085" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                </svg>
                            }
                            allowClear
                        />
                        <Select
                            value={selectedRegion}
                            onChange={handleLangChangeRegion}
                            style={{width: 180}}
                            options={regionsOptions}
                            className={'districtsSelect'}
                        />
                        <Select
                            value={selectedDistrict}
                            onChange={handleLangChangeDistrict}
                            style={{width: 180}}
                            options={districtsOptions}
                            className={'districtsSelect'}
                        />
                    </div>
                    <RangePicker onChange={onDateChange} placeholder={['Startdatum', 'Enddatum']}/>
                </div>
                {
                    !isDataLoading
                    ?
                        <DataGridPro
                            localeText={deDELocaleText}
                            sx={{
                                borderRadius: '8px',
                                border: '1px solid var(--Gray-200, #EAECF0)',
                                background: '#FFF)',
                                boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
                                "& .MuiDataGrid-cellContent": {
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: '#101828',
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 500,
                                    color: '#667085',
                                    fontSize: '12px',
                                    lineHeight: '18px',
                                },
                                "& .MuiDataGrid-cell:focus": {
                                    outline: 'none'
                                },

                            }}
                            apiRef={apiRef}
                            getRowId={e => e.id}
                            rows={gridRows}
                            {...gridRows}
                            hideFooterSelectedRowCount
                            sortingOrder={['desc', 'asc']}
                            rowHeight={72}
                            columnHeaderHeight={44}
                            columns={columns}
                            pagination
                            filterModel={filterModel}
                            onFilterModelChange={(newModel) => setFilterModel(newModel)}
                            sortModel={sortModel}
                            onSortModelChange={(newModel) => setSortModel(newModel)}
                            slots={{pagination: GridPagination}}
                            paginationModel={{pageSize: 10, page}}
                            onPaginationModelChange={(model) => {
                                onChangeGridPage(model.page);
                            }}
                            pageSizeOptions={[10, 25, 50]}
                            initialState={{
                                pinnedColumns: {
                                    right: ['_'],
                                },
                                sorting: {
                                    sortModel: [{field: 'date_created', sort: 'desc'}],
                                },
                            }}
                        />
                        :
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '65vh',
                            flexDirection: 'column'
                        }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#1F553B' }} spin />} />
                        </div>
                }





            </div>
        </div>
    );
};

export default Requests;
